import { render, staticRenderFns } from "./inner.vue?vue&type=template&id=53e6251a&scoped=true&"
import script from "./inner.vue?vue&type=script&lang=js&"
export * from "./inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6251a",
  null
  
)

export default component.exports